module.exports = __webpack_public_path__ + "img/heroBg.2c313612.webp";